import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './config';

export async function uploadFile(file, path) {
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
}

// Laster opp en liste med foto-filer, returnerer array med download-URLer
export async function uploadPhotos(files, basePath) {
  const uploads = Array.from(files).map((file, i) => {
    const ext  = file.name.split('.').pop();
    const path = `${basePath}/${Date.now()}_${i}.${ext}`;
    return uploadFile(file, path);
  });
  return Promise.all(uploads);
}

// Dokumenter lagres med sti (ikke nedlastings-URL): kun eier og admin kan lese filen.
export async function uploadDocumentFile(file, uid, docKey) {
  const safe = file.name.replace(/[^\w.\-]+/g, '_').slice(-80);
  // Unik sti per opplasting: eieren kan bare opprette nye filer (storage.rules), aldri overskrive.
  const unique = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const path = `driverDocs/${uid}/${docKey}/${unique}_${safe}`;
  await uploadBytes(ref(storage, path), file);
  return { path, name: file.name, contentType: file.type, size: file.size };
}

// Laster opp en base64 dataURL (signatur fra canvas) som PNG
export async function uploadDataUrl(dataUrl, path) {
  const res    = await fetch(dataUrl);
  const blob   = await res.blob();
  const file   = new File([blob], 'signature.png', { type: 'image/png' });
  return uploadFile(file, path);
}
